import React from 'react';
import '../styles/style.css'

export class Featuredtimeelapsed extends React.Component {
    convert( milliseconds ) {
        let day, hour, minute, seconds;
        seconds = Math.floor(milliseconds / 1000);
        minute = Math.floor(seconds / 60);
        seconds = seconds % 60;
        hour = Math.floor(minute / 60);
        minute = minute % 60;
        day = Math.floor(hour / 24);
        hour = hour % 24;
        if (day >= 1) {
            return `${day} days ago`;
        } else if (day === 0 && hour >= 1) {
            return `${hour} hour ${minute} minutes ago`;
        } else if (day === 0 && hour < 1 && minute >= 1) {
            return `${minute} minutes ago`;
        } else {
            return `${seconds} seconds ago`;
        }
    };

    render () {
        let diffmilliseconds = Date.now() - new Date(this.props.featureddatetime);
        let output = this.convert(diffmilliseconds);
        return <h6 className="text-muted">{output}</h6>;
    }
};